export const SomethingWentWrong = () => {
  return (
    <div className="cq-content">
      <p style={{ fontSize: "8rem", lineHeight: "normal" }}>SORRY</p>
      <p>
        Something went wrong on our end. Please try again in a few minutes.
      </p>
    </div>
  );
};
